import styled from "styled-components";

export const TableWrapper = styled.div`
  width: 100%;
  border: 1px solid #E5E7EB;
  border-radius: 0.75rem;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: #FFFFFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #FFFFFF;
`;

export const TableHeader = styled.thead`
  background-color: transparent;
`;

export const TableHeaderCell = styled.th`
  padding: 1rem 1.5rem;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 600;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  user-select: none;
  transition: color 0.2s;

  &:hover {
    color: #4B5563;
  }

  &.sortable {
    cursor: pointer;
  }

  .sort-icon {
    opacity: 0.4;
    transition: opacity 0.2s;
    display: inline-block;
  }

  &:hover .sort-icon {
    opacity: 1;
  }

  &.actions {
    text-align: right;
    cursor: default;
  }
`;

export const TableBody = styled.tbody`
  background-color: #FFFFFF;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #F3F4F6;
  transition: background-color 0.2s;

  &:hover {
    background-color: #F9FAFB;
  }

  &.empty-row {
    height: 12rem;

    td {
      text-align: center;
      padding: 3rem 1.5rem;
      color: #9CA3AF;
      background-color: #F9FAFB;
    }
  }
`;

export const TableCell = styled.td`
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  color: #111827;

  &.actions {
    text-align: right;
  }
`;

export const PaginationWrapper = styled.div`
  padding: 1rem 1.5rem;
  border-top: none;
  background-color: #F9FAFB;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const PaginationInfo = styled.div`
  font-size: 0.875rem;
  color: #6B7280;

  .number {
    font-weight: 500;
    color: #111827;
  }
`;

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

export const RowsPerPage = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #6B7280;

  select {
    appearance: none;
    padding: 0.375rem 2rem 0.375rem 0.75rem;
    background-color: #ffffff;
    border: 1px solid #D1D5DB;
    border-radius: 0.375rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

    &:hover {
      border-color: #9CA3AF;
    }

    &:focus {
      outline: none;
      border-color: #021526;
      box-shadow: 0 0 0 3px rgba(2, 21, 38, 0.1);
    }
  }
`;

export const PaginationButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 2rem;
    height: 2rem;
    padding: 0 0.5rem;
    background-color: #ffffff;
    border: 1px solid #E5E7EB;
    border-radius: 0.375rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s;

    &:hover:not(:disabled):not(.active) {
      background-color: #F9FAFB;
      border-color: #D1D5DB;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &.active {
      background-color: #021526;
      border-color: #021526;
      color: #ffffff;
    }

    svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;

export const PaginationEllipsis = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.5rem;
  font-size: 0.875rem;
  color: #6B7280;
  user-select: none;
`;

